import React from 'react'

const RightArrowSvg = () => {
  return (
		<svg
			width="14"
			height="15"
			viewBox="0 0 14 15"
			xmlns="http://www.w3.org/2000/svg"
			className="right-arrow-svg"
			style={{ fill: "#315D9E" }}
		>
			<path
				d="M0 7.97656L10.631 7.97656L5.731 12.8766L7 14.1016L14 7.10156L7 0.101562L5.775 1.32656L10.631 6.22656L0 6.22656L0 7.97656Z"
			/>
		</svg>
	);
}

export default RightArrowSvg
